module.exports = __webpack_public_path__ + "static/media/service4.7445e878.jpeg";